/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loose_Candid_Pony_AscendInputs */

const en_loose_candid_pony_ascend = /** @type {(inputs: Loose_Candid_Pony_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const de_loose_candid_pony_ascend = /** @type {(inputs: Loose_Candid_Pony_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Loose_Candid_Pony_AscendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loose_candid_pony_ascend = /** @type {((inputs?: Loose_Candid_Pony_AscendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loose_Candid_Pony_AscendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loose_candid_pony_ascend(inputs)
	return de_loose_candid_pony_ascend(inputs)
});